<template>
  <newsletterTypeDialog
      v-if="!newsletterType"
      v-model="display"
      @select="($event) => {newsletterType = $event}"
  />
  <ws-dialog
      v-else
      persistent
      v-model="display"
      :title="$t('avalon.website.setup.title')"
      blank
      fullscreen
      :background-color="wsLIGHTCARD"
      no-navigation
      not-centered
      no-padding
  >

    <template #header>
      <portal-target name="finemailer_wizzard_header">
      </portal-target>
    </template>

    <template #default>

      <newsletter-wizard-templates
        v-if="step === 0"
        @select="handleTemplateSelect"
        :newsletter-type="newsletterType"
        @close="display = false"
      />
      <email-constructor
          v-if="step === 1"
          :uuid="newsletterDesignId"
          :newsletter-id="entityData.uuid"
          @close="display = false"
      />
      <newsletter-wizard-settings
          v-if="step === 2"
          @update="updateNewlstter"
          :newsletter-type="newsletterType"
          :newsletter="entityData"
          @close="display = false"
      />

      <start-newsletter-dialog
          v-if="displaySendDialog"
          v-model="displaySendDialog"
          :newsletter="entityData"
          :no-redirect="fromLetter"
          @success="handleReturnToLetter"
      />

      <ws-dialog
          v-if="displayResetDesignDialog"
          v-model="displayResetDesignDialog"
          :title="$t('mailer.wizard.reset_design.title')"
          :save-text="$t('Proceed')"
          @save="resetNewlsetterDesign"
      >
        <h4 class="wsACCENT font-weight-regular">{{ $t('mailer.wizard.reset_design.warning') }} </h4>
      </ws-dialog>

    </template>

    <template #footer>
      <wizard-navigation-footer
          v-model="step"
          @test-email="$store.state.finemailer.displayTestEmailTrigger++"
          @back="prevStep"
          @next="nextStep"
          :items="navigationItems"
          @step-name="stepName = $event"
          :disable-next="disableNextCondition"
      />
    </template>

  </ws-dialog>

</template>

<script>
import newsletterTypeDialog
  from "@/modules/finemailer/components/newsletterWizard/newsletterTypeDialog";
import newsletterWizardSettings
  from "@/modules/finemailer/components/newsletterWizard/newsletterWizardSettings";
import newsletterWizardTemplates
  from "@/modules/finemailer/components/newsletterWizard/newsletterWizardTemplates";
import EmailConstructor from "@/modules/finemailer/components/emailConstructor/EmailConstructor";
import wizardNavigationFooter
  from "@/modules/finemailer/components/newsletterWizard/UI/wizardNavigationFooter";
import  {mapState,mapActions} from "vuex";
import startNewsletterDialog from "@modules/finemailer/components/campaigns/startNewsletterDialog.vue";


export default {
  name: "NewsletterWizard",
  components : {
    startNewsletterDialog,
    newsletterTypeDialog,
    newsletterWizardSettings,
    newsletterWizardTemplates,
    EmailConstructor,
    wizardNavigationFooter
  },
  props : {
    value : {
      type : Boolean
    },
    newsletter : {
      type : Object,
      default() { return {} }
    },
    single : {
      type : Boolean,
      default : false
    },
    auto : {
      type : Boolean,
      default : false
    },
    fromLetter : {
      type : Boolean,
      default : false
    }
  },
  data() {
    return {
      display : false,
      newsletterType : null,
      step : 0,
      stepName : null,
      entityData : {},
      newsletterDesignId : null,
      displaySendDialog : false,
      displayResetDesignDialog : false,
      resetTemplate : false,
    }
  },
  computed : {
    ...mapState('finemailer' , ['triggerSendNewsletter']),

    disableNextCondition() {
      if ( !this.newsletterDesignId ) {
        return true
      }
      if ( this.step === 2 ) {
        return !this.entityData.filters.length
      }
      return false
    },

    navigationItems() {
      return [
        { text : this.$t('Templates'), value : 'templates' },
        { text : this.$t('Content!'), value : 'content' },
        { text : this.$t('Settings'), value : 'settings' },
      ]
    }
  },
  watch : {
    triggerSendNewsletter() {
      this.displaySendDialog = true
    },
    display() {
      if ( this.value !== this.display ) {
        this.$emit('input' , this.display)
      }
    },
    value() {
      if ( this.value !== this.display ) {
        this.display = this.value
      }
    }
  },
  methods : {
    ...mapActions('finemailer' , [
      'ADD_EDIT_NEWSLETTER',
      'RESET_NEWSLETTER_DESIGN',
      'GET_NEWSLETTER',
    ]),

    async resetNewlsetterDesign() {
      let data = {
        uuid : this.entityData.uuid,
        template : this.resetTemplate
      }
      let result = await this.RESET_NEWSLETTER_DESIGN(data)
      if (!result) {
        return this.ERROR()
      }
      this.newsletter.newsletter_design_id = result.newsletter_design_id
      this.entityData.newsletter_design_id = result.newsletter_design_id
      this.newsletterDesignId = result.newsletter_design_id
      this.step = 1
    },
    handleReturnToLetter() {
      if (this.fromLetter) {
        this.display = false
      }
    },
    handleTemplateSelect(template) {
      if (this.entityData.uuid) {
        this.resetTemplate = template
        this.displayResetDesignDialog = true
        return
      }
      this.createNewsletter(template)
    },
    async createNewsletter(template) {
      // newsletterLoading = true
      let data = {
        type : this.newsletterType,
        template : template
      }
      let result = await this.ADD_EDIT_NEWSLETTER(data)
      if ( !result ) {
        return this.ERROR()
      }
      this.entityData = result
      this.newsletterDesignId = result.newsletter_design_id
      this.$emit('create' , result)

      this.step = 1
    },

    updateNewlstter($event) {
      this.newsletter = this.COPY($event)
      this.entityData = this.COPY($event)
      this.$emit('update' , this.entityData)
    },
    async initPage() {
      if ( !this.newsletter.uuid ) {
        return
      }

      this.entityData = (await this.GET_NEWSLETTER(this.newsletter.uuid)) ?? this.newsletter
      this.newsletterType = this.newsletter.is_automation ? 'auto' : 'single'
      this.newsletterDesignId = this.newsletter.newsletter_design_id
      this.step = 1

    },

    // technical
    prevStep() {
      if ( this.step === 0 ) {
        this.display = false
        return
      }
      if (this.step > 0) {
        this.step--
      }
    },
    nextStep() {
      if ( this.step === 2) {
        this.$store.state.finemailer.triggerSendNewsletter++
        return
      }
      this.step++
    },
  },
  beforeMount() {
    if ( this.single) {
      this.newsletterType = 'single'
    }
    if ( this.auto) {
      this.newsletterType = 'auto'
    }
  },
  mounted() {
    this.initPage()
    if ( this.value ) {
      this.display = this.value
    }

  }
}
</script>

<style scoped>

</style>